import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import DragCalendar from './DragCalendar';

const DraggableContain = () => {
  return (
    <Container className='calendar-basic' fluid={true}>
      <Breadcrumbs pageTitle='Dragable Calender' parent='Apps' title='Dragable Calender' />
      <Row>
        <Col sm='12'>
          <Card className='calendar-default'>
            <CardBody>
              <Row>
                <DragCalendar />
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default DraggableContain;
